<template>
  <div>
    <div class="position-relative">
      <section class="section section-lg section-hero section-shaped">
        <!-- Background circles -->
        <div class="shape shape-style-1 shape-primary">
          <span class="span-150"></span>
          <span class="span-50"></span>
          <span class="span-50"></span>
          <span class="span-75"></span>
          <span class="span-100"></span>
          <span class="span-75"></span>
          <span class="span-50"></span>
          <span class="span-100"></span>
          <span class="span-50"></span>
          <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center py-lg">
          <div class="col px-0">
            <div class="row align-items-center justify-content-center">
              <div class="col-lg-6 text-center">
                <h1 class="text-white">Hola, soy Diego Jovanny</h1>
                <p class="lead text-white">
                  Desarrollador informático a medida, especializado en sistemas
                  ágiles y modernos.
                </p>
                <div class="btn-wrapper mt-5">
                  <a href="/sobre_mi" class="btn btn-sm btn-default btnMio">
                    <span
                      class="
                        btn-inner--text
                        text-white
                        btn btn-sm btn-icon
                        mb-3 mb-sm-0
                      "
                      >Un poco sobre mi</span
                    >
                  </a>
                  <a href="/portafolio" class="btn btn-sm btn-default btnMio">
                    <span
                      class="
                        btn-inner--text
                        text-white
                        btn btn-sm btn-icon
                        mb-3 mb-sm-0
                      "
                      >Mi Portafolio</span
                    >
                  </a>
                </div>
                <div class="mt-5">
                  <img alt="image" src="faviconD.ico" style="height: 28px" />
                  <small class="text-white font-weight-bold mb-0 mr-2 ml-1"
                    >*Desarrollador Web</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- SVG separator -->
        <div class="separator separator-bottom separator-skew zindex-100">
          <svg
            x="0"
            y="0"
            viewBox="0 0 2560 100"
            preserveAspectRatio="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon class="fill-white" points="2560 0 2560 100 0 100" />
          </svg>
        </div>
      </section>
    </div>
    <section
      class="ftco-about img ftco-section ftco-no-pt ftco-no-pb"
      id="about-section"
    >
      <div class="container">
        <div class="row d-flex no-gutters">
          <div class="col-md-6 col-lg-6 d-flex">
            <div class="img-about img d-flex align-items-stretch">
              <div class="overlay"></div>
              <div class="img d-flex align-self-stretch align-items-center">
                <img
                  id="miFoto"
                  src="../assets/img/dyegos.jpg"
                  alt="Dyego Vallejo"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 pl-md-5 py-5">
            <div class="row justify-content-start pb-3">
              <div
                class="
                  col-md-12
                  heading-section
                  ftco-animate
                  fadeInUp
                  ftco-animated
                "
              >
                <h1 class="big">Sobre mi</h1>
                <h2 class="mb-4"></h2>
                <p class="quienSoy">
                  Soy desarrollador web con conocimento en back-end y front-end.
                  Me destaco por ser una persona autodidacta para poder estar
                  actualizado en el desarrollo informático y entregar sistemas
                  de calidad.
                </p>
                <ul class="mt-4 px-md-0 px-2">
                  <li class="d-flex-lista">
                    <span class="info">Nombre:</span>
                    <span class="infoDatos">Diego Jovanny Vallejo B.</span>
                  </li>
                  <li class="d-flex-lista">
                    <span class="info">Ubicación:</span>
                    <span class="infoDatos">Ipiales- Nariño CO</span>
                  </li>
                  <li class="d-flex-lista">
                    <span class="info">Correo:</span>
                    <span class="infoDatos infoDatosEmail"
                      >dyegovallejob@gmail.com</span
                    >
                  </li>
                  <li class="d-flex-lista">
                    <span class="info">Celular:</span>
                    <span class="infoDatos"
                      ><a href="tel:+573184690679">+57 318 469 0679</a></span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="
                counter-wrap
                ftco-animate
                d-flex
                mt-md-3
                fadeInUp
                ftco-animated
              "
            >
              <div class="text">
                <p class="mb-4">
                  <span>Conoce un poco de más aquí</span>
                </p>
                <p>
                  <a
                    href="https://drive.google.com/file/d/1zMUirJLz7E5lX7-XOSkHZVrSZ8jOpDpl/view?usp=sharing"
                    target="_blank"
                    class="btn btn-default btn-sm btnMio float-left py-3 px-3"
                    >Descargar CV</a
                  >
                </p>
                <br />
                <br />
                <form
                  action="https://www.paypal.com/donate"
                  method="post"
                  target="_top"
                  class="mt-3"
                >
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="6LYSYDJBALUU2"
                  />
                  <input
                    type="image"
                    src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
                    border="0"
                    name="submit"
                    title="PayPal - The safer, easier way to pay online!"
                    alt="Donate with PayPal button"
                  />
                  <img
                    alt=""
                    border="0"
                    src="https://www.paypal.com/en_CO/i/scr/pixel.gif"
                    width="1"
                    height="1"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <br />

    <section class="section section-shaped">
      <div class="shape shape-style-1 shape-default">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-md">
        <div class="container">
          <div class="row row-grid align-items-center">
            <div class="col-md-6 order-md-2">
              <img
                src="../assets/img/theme/promo-1.png"
                class="img-fluid floating"
                alt="image"
              />
            </div>
            <div class="col-md-6 order-md-1">
              <div class="servicio1">
                <p class="tituloServicio">Desarrollo a Medida</p>
                <p id="sistemasMedidaP">
                  Estoy dedicado desde el 2017 al desarrollo de sistemas
                  informáticos a la medida, realizando:
                </p>
                <ul class="list-unstyled mt-5">
                  <li class="py-2">
                    <div class="d-flex align-items-center">
                      <div>
                        <div class="badge badge-circle badge-success mr-3">
                          <img
                            src="../assets/img/icons/robot.png"
                            class="img-fluid"
                            alt="image"
                          />
                        </div>
                      </div>
                      <div>
                        <p class="mb-0 listaSistemaMedia">Sistemas Modernos</p>
                      </div>
                    </div>
                  </li>
                  <li class="py-2">
                    <div class="d-flex align-items-center">
                      <div>
                        <div class="badge badge-circle badge-success mr-3">
                          <img
                            src="../assets/img/icons/seo.png"
                            class="img-fluid mt-"
                            alt="image"
                          />
                        </div>
                      </div>
                      <div>
                        <p class="mb-0 listaSistemaMedia">
                          Posicionamiento en Google
                        </p>
                      </div>
                    </div>
                  </li>
                  <li class="py-2">
                    <div class="d-flex align-items-center">
                      <div>
                        <div class="badge badge-circle badge-success mr-3">
                          <img
                            src="../assets/img/icons/sonrisa.png"
                            class="img-fluid"
                            alt="image"
                          />
                        </div>
                      </div>
                      <div>
                        <p class="mb-0 listaSistemaMedia">
                          Una gran experiencia para el Usuario
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- SVG separator -->
      <div class="separator separator-bottom separator-skew">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-white" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h3>Especializado en</h3>
            <br />
            <div class="row progress-circle mb-5">
              <div class="col-lg-6 mb-4">
                <div class="bg-white rounded-lg shadow p-4">
                  <h2 class="h5 font-weight-bold text-center mb-4">Laravel</h2>

                  <div class="row text-center mt-4">
                    <div class="col-6 border-right">
                      <div class="h4 font-weight-bold mb-0">70%</div>
                      <span class="small text-gray"
                        >Implementación en proyectos</span
                      >
                    </div>
                    <div class="col-6">
                      <img
                        src="../assets/img/laravel.png"
                        class="microsift img-fluid"
                        alt="Colorlib Template"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 mb-4">
                <div class="bg-white rounded-lg shadow p-4">
                  <h2 class="h5 font-weight-bold text-center mb-4">HTML5</h2>

                  <div class="row text-center mt-4">
                    <div class="col-6 border-right">
                      <div class="h4 font-weight-bold mb-0">100%</div>
                      <span class="small text-gray"
                        >Implementación en proyectos</span
                      >
                    </div>
                    <div class="col-6">
                      <img
                        src="../assets/img/html.png"
                        class="imgHTML img-fluid"
                        alt="Colorlib Template"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row progress-circle mb-5">
              <div class="col-lg-6 mb-4">
                <div class="bg-white rounded-lg shadow p-4">
                  <h2 class="h5 font-weight-bold text-center mb-4">
                    CSS3 / Bootstrap
                  </h2>

                  <div class="row text-center mt-4">
                    <div class="col-6 border-right">
                      <div class="h4 font-weight-bold mb-0">100%</div>
                      <span class="small text-gray"
                        >Implementación en proyectos</span
                      >
                    </div>
                    <div class="col-md-6">
                      <img
                        src="../assets/img/css3.png"
                        class="microsift img-fluid"
                        alt="Colorlib Template"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 mb-4">
                <div class="bg-white rounded-lg shadow p-4">
                  <h2 class="h5 font-weight-bold text-center mb-4">Angular</h2>

                  <div class="row text-center mt-4">
                    <div class="col-6 border-right">
                      <div class="h4 font-weight-bold mb-0">70%</div>
                      <span class="small text-gray"
                        >Implementación en proyectos</span
                      >
                    </div>
                    <div class="col-6">
                      <img
                        src="../assets/img/angular.png"
                        class="microsift img-fluid"
                        alt="Colorlib Template"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h3>Otros lenguajes</h3>
            <div class="row">
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Vue Js</span>
                    </div>
                    <div class="progress-percentage">
                      <span>65%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar vue"
                      role="progressbar"
                      aria-valuenow="65"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 65%"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Sql</span>
                    </div>
                    <div class="progress-percentage">
                      <span>70%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar bg-secundary"
                      role="progressbar"
                      aria-valuenow="70"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 70%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Django</span>
                    </div>
                    <div class="progress-percentage">
                      <span>40%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar django"
                      role="progressbar"
                      aria-valuenow="40"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 40%"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>PostgreSQL</span>
                    </div>
                    <div class="progress-percentage">
                      <span>60%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar psql"
                      role="progressbar"
                      aria-valuenow="60"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 60%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Node (Express)</span>
                    </div>
                    <div class="progress-percentage">
                      <span>70%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      aria-valuenow="70"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 70%"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Nest</span>
                    </div>
                    <div class="progress-danger">
                      <span>30%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar bg-danger"
                      role="progressbar"
                      aria-valuenow="30"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 30%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Java spring boot</span>
                    </div>
                    <div class="progress-percentage">
                      <span>30%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      aria-valuenow="30"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 30%"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Firebase</span>
                    </div>
                    <div class="progress-percentage">
                      <span>40%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar bg-warning"
                      role="progressbar"
                      aria-valuenow="40"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 40%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Mongo</span>
                    </div>
                    <div class="progress-percentage">
                      <span>50%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 50%"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="progress-wrapper">
                  <div class="progress-info">
                    <div class="progress-label">
                      <span>Ionic</span>
                    </div>
                    <div class="progress-percentage">
                      <span>55%</span>
                    </div>
                  </div>
                  <div class="progress">
                    <div
                      class="progress-bar ionic"
                      role="progressbar"
                      aria-valuenow="55"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style="width: 55%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h5>Otras herramiestas</h5>
        <div class="row">
          <div class="col-md-4">
            <div class="progress-wrapper">
              <div class="progress-info">
                <div class="progress-label">
                  <span>Photoshop</span>
                </div>
                <div class="progress-percentage">
                  <span>50%</span>
                </div>
              </div>
              <div class="progress">
                <div
                  class="progress-bar bg-secundary"
                  role="progressbar"
                  aria-valuenow="50"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 50%"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="progress-wrapper">
              <div class="progress-info">
                <div class="progress-label">
                  <span>Adobe XD</span>
                </div>
                <div class="progress-percentage">
                  <span>50%</span>
                </div>
              </div>
              <div class="progress">
                <div
                  class="progress-bar bg-secundary"
                  role="progressbar"
                  aria-valuenow="50"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 50%"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="progress-wrapper">
              <div class="progress-info">
                <div class="progress-label">
                  <span>After Effects</span>
                </div>
                <div class="progress-percentage">
                  <span>45%</span>
                </div>
              </div>
              <div class="progress">
                <div
                  class="progress-bar aft"
                  role="progressbar"
                  aria-valuenow="45"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 45%"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="sk-chase">
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
        </div>
        <p class="aprender">Aprendiendo nuevas tecnologías...</p>
      </div>
    </section>
    <footer class="footer has-cards">
      <div class="container container-lg">
        <h3>Algunos Proyectos:</h3>
        <br />
        <div class="row">
          <div class="col-md-6 mb-5 mb-md-0">
            <div class="card card-lift--hover shadow border-0">
              <a
                href="https://www.depaseohviajesyturismo.com/"
                target="_blank"
                title="Landing Page"
              >
                <img src="../assets/img/paseo.jpg" class="card-img" />
              </a>
            </div>
          </div>
          <div class="col-md-6 mb-5 mb-lg-0">
            <div class="card card-lift--hover shadow border-0">
              <a
                href="https://www.quiropraxiaysaludipiales.com/"
                target="_blank"
                title="Profile Page"
              >
                <img src="../assets/img/lectorami.png" class="card-img" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row row-grid align-items-center my-md">
          <div class="col-lg-6">
            <h3 class="text-primary font-weight-light mb-2">
              Gracias por su visita!
            </h3>
            <h4 class="mb-0 font-weight-light">Conoce más de mi aquí.</h4>
          </div>
          <div class="col-lg-6 text-lg-center btn-wrapper">
            <a
              target="_blank"
              href="https://www.facebook.com/diego.vallejo.52"
              class="btn btn-neutral btn-icon-only btn-facebook btn-round"
              data-toggle="tooltip"
              data-original-title="Like us"
            >
              <i class="fab fa-facebook-square"></i>
            </a>
            <a
              target="_blank"
              href="https://www.linkedin.com/in/dyego-vallejo-536945149/"
              class="btn btn-neutral btn-icon-only btn-dribbble btn-round"
              data-toggle="tooltip"
              data-original-title="Follow us"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              target="_blank"
              href="https://github.com/dyeyo"
              class="btn btn-neutral btn-icon-only btn-github btn-round"
              data-toggle="tooltip"
              data-original-title="Star on Github"
            >
              <i class="fab fa-github-square"></i>
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/dyegoyovanny/?hl=es-la"
              class="btn btn-neutral btn-icon-only btn-twitter btn-round"
              data-toggle="tooltip"
              data-original-title="Follow us"
            >
              <i class="fab fa-instagram-square"></i>
            </a>
            <br />
            <form
              action="https://www.paypal.com/donate"
              method="post"
              target="_top"
            >
              <input
                type="hidden"
                name="hosted_button_id"
                value="6LYSYDJBALUU2"
              />
              <input
                type="image"
                src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
                border="0"
                name="submit"
                title="PayPal - The safer, easier way to pay online!"
                alt="Donate with PayPal button"
              />
              <img
                alt=""
                border="0"
                src="https://www.paypal.com/en_CO/i/scr/pixel.gif"
                width="1"
                height="1"
              />
            </form>
          </div>
        </div>
        <hr />
        <div class="row align-items-center justify-content-md-between">
          <div class="col-md-6">
            <div class="copyright">
              © 2020
              <a href="#" target="_blank">Diego Vallejo</a>.
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Banner",
};
</script>